<template>
  <div class="min-h-screen">
    <div class="w-full flex flex-col justify-center items-center pt-20 gap-5">
      <p class="text-5xl text-surface-500">LOGGING IN</p>
      <ProgressSpinner style="width: 300px; height: 300px" class="fill-surface-0 dark:fill-surface-800 mx-auto" animationDuration=".5s" />
      <p class="text-5xl text-surface-500">PLEASE WAIT...</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { sso } from "@/services/SSOService";
import { useAuthStore } from "@/stores/auth";
import { usePropsStore } from "@/stores/props";
import type { Tokens } from "@/types/Token";

const router = useRouter();
const authStore = useAuthStore();

onBeforeMount(async (): Promise<void> => {
  setTimeout(() => {
    const propsStore = usePropsStore();
    if (propsStore.ssoEnabled) {
      sso.getIDToken().then((token) => {
        if (token != null) {
          axios.post("/admin-sso-login", token).then((response) => {
            handleApiResponse(
              response,
              (data: Tokens) => {
                const token = data;
                authStore.token = token.accessToken;
                authStore.refreshToken = token.refreshToken;
                authStore.refreshing = false;
                authStore.sessionExpired = false;
                authStore.forcePasswordChange = token.forcePasswordChange;
                const userInfo = authStore.getUserInfo();
                info("Welcome", userInfo.firstName + " " + userInfo.lastName);
                if (authStore.forcePasswordChange) {
                  router.push({
                    name: userInfo.scope === "ADMIN" ? "change-pass" : "portal-change-pass",
                  });
                } else if (userInfo.scope === "ADMIN") {
                  router.push({
                    name: "admin-dashboard",
                  });
                } else {
                  router.push({
                    name: "portal-project-list",
                  });
                }
              },
              (errors: ApiError[]) => {
                router.push({
                  name: "admin-login",
                });
                error("Login Error", errors[0].message);
              }
            );
          });
        }
      });
    }
  }, 1000);
});
</script>
